import { createFileRoute } from '@tanstack/react-router';
import { GoalsPage } from '@/features/goals/pages/goals-page';

/** Enterprise monthly goals: branch + staff targets, pace and forecast. */
export const Route = createFileRoute('/_app/goals')({ component: GoalsPage });
